import React from "react";
import { Nav } from "react-bootstrap";
function Logout() {
  async function handleLogout() {
    window.location.assign("/logged-out");
  };


  return (
    <Nav.Link className="header-element" style={{color: "black", padding: 0, margin: 0}} onClick={handleLogout}>
      Log Out
    </Nav.Link>
  );
}

export default Logout;